<template>
	<div class="banner-wrapper">
		<div class="banner" v-if="showBanner">
			<div class="col1">
				<img
					class="banner-img"
					src="/appassets/img/banner/title-removal-banner.png"
					alt="Title removal banner"
				/>
			</div>
			<div class="col2">
				<div class="close-button" @click="close">
					<FontAwesomeIcon :icon="faTimes" />
				</div>
				<p>Download the mobile app to continue having full functionality!</p>
				<a :href="applicationUrl" target="_blank" rel="noopener">
					<BasicButton @click="clickout" color="primary">Download now</BasicButton>
				</a>
			</div>
			<div class="close-button" @click="close">
				<FontAwesomeIcon :icon="faTimes" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import BasicButton from '@/ui-components/BasicButton.vue';
import { COUNTRY_WITHOUT_TITLEDETAIL } from '@/constants/web-locales.constant';
import { computed, ref } from 'vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

const { webLocale } = storeToRefs(useLanguageStore());

const isClosed = ref(false);
const showBanner = computed(() => !isClosed.value && COUNTRY_WITHOUT_TITLEDETAIL.includes(webLocale.value));

const appLink = {
	ios: 'https://apps.apple.com/app/apple-store/id979227482',
	android: 'https://play.google.com/store/apps/details?id=com.justwatch.justwatch',
};

const applicationUrl = computed(() => {
	const userAgent = window.navigator.userAgent;

	if (!userAgent) return '';

	if (userAgent.match(/Windows|Linux/i) || userAgent.match(/android/i)) return appLink.android;
	if (userAgent.match(/Macintosh/i) || userAgent.match(/(iPhone|iPad)/)) return appLink.ios;

	return '';
});

function close() {
	isClosed.value = true;
	TrackingHelper.trackEvent('titleremovalbanner', {
		action: 'hide_click',
	});
}

function clickout() {
	TrackingHelper.trackEvent('titleremovalbanner', { action: 'clickout' });
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';
@import '~@/styles/rtl-support-mixins';

.banner-wrapper {
	display: flex;
	position: fixed;
	bottom: 10px;
	left: 0;
	right: 0;
	z-index: 999;
}

.banner {
	position: relative;
	display: flex;
	background: #111924;
	border-radius: 8px;
	width: 100%;
	overflow: hidden;
	color: #c6c8cd;
	max-height: 80px;
	max-width: 864px;
	margin: 0 auto;
	z-index: 999;
	bottom: 0px;

	.col2 {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		gap: 20px;
	}

	.close-button {
		position: absolute;
		top: 0;
		right: 0;
		padding: 15px 20px;
		cursor: pointer;
	}
}

@media (max-width: $screen-sm) {
	.banner-wrapper {
		margin: 20px 20px;

		.banner {
			max-height: 275px;
			padding: 20px;

			.banner-img {
			}

			.col2 {
				display: flex;
				flex-direction: column;
				font-weight: bold;
				max-width: 550px;
				align-items: flex-start;

				p {
					margin: 0;
					padding: 0;
					font-size: 16px;
				}

				button {
					max-width: fit-content;
					margin: 20px 0px;
					font-size: 16px;
				}
			}
		}
	}
}
</style>
